import { Duration, intervalToDuration, isAfter, isEqual } from 'date-fns'
import { interval, Observable, startWith } from 'rxjs'
import { map } from 'rxjs/operators'

export function getCountdownDuration(date: Date): Observable<Duration | null> {
  return interval(1000).pipe(
    startWith(0),
    map(() => {
      const now = new Date()
      if (isEqual(now, date) || isAfter(now, date)) {
        return null
      }
      return intervalToDuration({ start: now, end: date })
    }),
  )
}
